<nb-card class="dialog">
  <nb-card-header>
    <h4>{{ "pages.creator.rename.title" | translate }}</h4>
  </nb-card-header>
  <nb-card-body>
    <div class="field">
      <label class="label" for="creator-rename-title">{{ "pages.creator.rename.label" | translate }}</label>
      <input
        id="creator-rename-title"
        nbInput
        fullWidth
        type="text"
        maxlength="255"
        [formControl]="name"
      />
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button type="button" nbButton status="danger" outline (click)="cancel()" [disabled]="working">
      {{ "buttons.cancel" | translate }}
    </button>
    <button type="button" nbButton status="primary" [nbSpinner]="working" [disabled]="working" (click)="submit()">
      {{ "buttons.save" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
